import React, { useState } from 'react'
import { t, Trans } from '@lingui/macro'

import { linkBuilder } from '../../../../shared/linkBuilder'
import { navigateTo } from '../../app/util/appHistory'
import Tag from '../../components/common/tag/Tag'
import SurveyResultBar from './components/survey-result-bar/SurveyResultBar'
import DuplicateSurveyModal from './DuplicateSurveyModal'
import SurveyStatus from './SurveyStatus'
import { ISurvey } from './types'
import {
  ButtonIcon,
  ButtonLight,
  ButtonOutline,
  Flex
} from 'front-end/src/components'
import IconDuplicate from 'front-end/src/components/common/icon/IconDuplicate'
import { brandColors } from 'shared/basicPalette'

interface IProps {
  survey: ISurvey
}

const SurveyItem = ({ survey }: IProps) => {
  const [showDuplicateModal, setShowDuplicateModal] = useState<boolean>(false)

  return (
    <>
      <article
        className={`ListItem ${
          !survey.published_at && !survey.completed_at ? 'draft' : 'open'
        }`}
        onClick={() => {
          navigateTo(linkBuilder.surveyDetailManage(survey.id))
        }}
      >
        <div className="ListItem__title">
          <h2>{survey.title}</h2>

          <div className="ListItem__subtitle">
            <span className="ListItem__questionsCount">
              <Trans>{survey.questions.length} questions</Trans>
            </span>
            {survey.tags &&
              survey.tags.map((tag) => (
                <Tag key={tag.name} size="small">
                  {tag.name}
                </Tag>
              ))}
          </div>
        </div>
        <SurveyStatus
          isPublished={!!survey.published_at}
          isCompleted={!!survey.completed_at}
        />
        <SurveyResultBar responses={survey.responses} />
        <Flex
          minW={['100px', '100px', '100px', '100px', '220px']}
          justifyContent="flex-end"
        >
          {survey.responses.completedCount > 0 ? (
            <ButtonLight
              onClick={() => {
                navigateTo(
                  `${linkBuilder.surveyDetailManage(survey.id)}/results`
                )
              }}
            >
              <Trans>View results</Trans>
            </ButtonLight>
          ) : (
            <ButtonOutline
              onClick={() => {
                navigateTo(linkBuilder.surveyDetailManage(survey.id))
              }}
            >
              <Trans>No results yet</Trans>
            </ButtonOutline>
          )}
        </Flex>
        <ButtonIcon
          className="ListItem__duplicate"
          hint={t`Copy`}
          aria-label={t`Copy`}
          circular
          onClick={(e) => {
            e.stopPropagation()
            setShowDuplicateModal(true)
          }}
          icon={<IconDuplicate color={brandColors.grey[500]} boxSize="16px" />}
        />
      </article>
      <DuplicateSurveyModal
        show={showDuplicateModal}
        onHide={() => {
          setShowDuplicateModal(false)
        }}
        survey={survey}
      />
    </>
  )
}

export default SurveyItem
